<template>
  <div>
    <!-- 중앙모달 -->
    <div :class="{ savefile: true, modal: true, center: true, on: true }">
      <div class="save-cover"></div>
      <h1>클라우드 파일 저장</h1>
      <section class="inner">
        <form @submit.prevent="submit">
          <fieldset>
            <legend>파일 저장</legend>
            <div class="save-name">
              <label>note</label>
              <input ref="input" type="text" v-model="title" maxlength="100">
            </div>
            <ul class="file-element">
              <li>
                <i class="material-icons"> done </i>
                <span> 파일 사이즈</span>
                <b>{{ size }}</b>
              </li>
              <li>
                <i class="material-icons"> done </i><span> 파일 형식</span>
                <b>{{ type }}</b>
              </li>
              <li>
                <i class="material-icons"> done </i><span>Bit Rate</span>
                <b>448000 Hz</b>
              </li>
              <li>
                <i class="material-icons"> done </i><span>채널</span>
                <b>2 Channel</b>
              </li>
              <li>
                <i class="material-icons"> done </i>
                <span>녹음시간</span>
                <b>{{ time }}초</b>
              </li>
            </ul>

            <article>저장된 파일은 스토리지에서 확인 할수 있습니다.</article>
            <div class="btns">
              <button type="submit" class="on">확인</button>
            </div>
            <!-- <div class="btns">
              <button type="button" @click="noiseCancel" class="on">
                NoisCancel
              </button>
            </div> -->
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>
<script>
// import _ from "lodash";
// import { createConfirmAuth } from "@/api/member";
// import { createLogin } from "@/api/member";
import { mapState } from "vuex";
import { timer } from "@/mixins/timer";
import { eventBus } from "@/main";
import { createRecordFile, deleteFile } from "@/api/index";
// import { eventBus } from "@/main";
export default {
  mixins: [timer],
  // props: ["size", "type", "blob", "fileUrl", "time"],
  props: {
    size: {
      type: Number
    },
    time: {
      type: Number
    },
    type: {
      type: String,
      default: ""
    },
    fileUrl: {
      type: String
    },
    sampleRate: {
      type: String,
      default: ""
    },
    bitRate: {
      type: String,
      default: ""
    },
    channel: {
      type: Number,
      default: 0
    },
    charge: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      message: "정상적으로 처리 되었습니다.",
      showSnackbar: false,
      count: null,
      title: ""
    };
  },

  mounted() {
    this.$refs.input.focus();
    // this.timer();
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    closeModal() {
      eventBus.$emit("closeModal", true);
    },
    handleKey(event) {
      let code = event.keyCode;
      window.console.log("code", code);
      if (code > 47 && code < 58) {
        event.target.nextElementSibling.focus();
        return;
      } else if (code == 37) {
        event.target.previousElementSibling.focus();
        return;
      } else if (code == 39) {
        event.target.nextElementSibling.focus();
        return;
      } else if (code == 8) {
        event.target.previousElementSibling.focus();
        return;
      }
      event.preventDefault();
    },

    handleDelte(index, path, type) {
      window.console.log("index", index);
      window.console.log("path", path);
      window.console.log("type", type);

      deleteFile(path).then(res => {
        window.console.log("res delteFile", res);

        if (res.status == 200) {
          if (index == 0 && type == "profileImage") {
            this.trainerInfo.profileImages.splice(index, 1);
          } else {
            this.trainerInfo.certFiles.splice(index, 1);
          }
        } else {
          return alert(res.data.message);
        }
      });
    },
    submit() {
      window.console.log("submit >>>");

      let data = {
        url: this.fileUrl,
        title: this.title,
        type: this.type,
        size: this.size,
        time: this.time,
        sampleRate: this.sampleRate,
        bitRate: this.bitRate,
        channel: this.channel,
        charge: this.charge,
        unit: this.unit
      };
      createRecordFile(data).then(res => {
        if (res.status === 200) {
          window.console.log("createRecordFile res", res);
          // this.addFilePath(res.data.path);
          this.closeModal();
        }
      });
    },
    noiseCancel() {
      let NoiseCancel = require("@/libs/api_noise_cancel.js");

      function callback_progress_bar(percent) {
        window.console.log("progress bar: " + percent + "%");
      }

      function callback_on_close(code, output_filename) {
        let success_fail =
          code == 0 ? "Job Success" : "Job failed by unknown problem";
        window.console.log(success_fail);
        if (code == 0) {
          window.console.log("output file name=" + output_filename);
        }
      }
      let file = this.fileUrl;
      window.console.log("file", file);
      let noiseCancel = new NoiseCancel(
        file, //input file url
        callback_progress_bar, //진행률이 update될 때마다 call 되는 함수.
        callback_on_close //subprocess가 끝날때 불려질 callback 함수
      );
      window.console.log("noiseCancel", noiseCancel);
    }
  }
};
</script>